import { render, staticRenderFns } from "./ui-checkbox.vue?vue&type=template&id=03ba6f52&scoped=true&"
import script from "./ui-checkbox.vue?vue&type=script&lang=js&"
export * from "./ui-checkbox.vue?vue&type=script&lang=js&"
import style0 from "./ui-checkbox.vue?vue&type=style&index=0&id=03ba6f52&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "03ba6f52",
  null
  
)

export default component.exports